module.exports = __webpack_public_path__ + "img/thumbnail_Mandrill_j_normal.9b4ba0d9.png";